<template>
  <div class="animated fadeIn">
    <b-row class="mt-2">
      <b-col md="12">
        <component-header
          title="View FAQ"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Faqs' })"
        />
      </b-col>
      <b-col md="12" class="custome-card">
        <b-card>
          <b-row v-if="userRole === 'Tenant'">
            <b-col sm="6">
              <b-form-group label="Scope" label-for="Scope" :label-cols="3">
                <b-form-input
                  type="text"
                  id="scope"
                  placeholder="Scope"
                  v-model="faqData.scope"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Category"
                label-for="Category"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="category"
                  v-model="faqData.category"
                  placeholder="Category"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group label="Topic" label-for="Topic" :label-cols="3">
                <b-form-input
                  type="text"
                  id="topic"
                  placeholder="Topic"
                  v-model="faqData.Topic"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Description"
                label-for="Description"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="description"
                  placeholder="Description"
                  v-model="faqData.Description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="MediaType"
                label-for="MediaType"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="mediatype"
                  placeholder="MediaType"
                  v-model="faqData.mediaType"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col
                sm="4"
              >
                <b-form-group
                  class="m-0"
                  label="Media Content"
                  label-for="SmallImage"
                ></b-form-group>
              </b-col>
              <b-col sm="2">
                <eb-button
                  classic="btn-primary"
                  text="Download Content"
                  @click="downloadFile"
                ></eb-button>
              </b-col>
            </b-row> 
            <b-row class="mt-2 ml-1">
              <b-col sm="6">
                  <img
                    v-if="faqData.mediaType === 'IMAGE'"
                    :src="faqData.mediaContent"
                    style="height: 200px; width: 450px"
                  />
                  <video
                  v-if="faqData.mediaType === 'VIDEO'"
                  :src="faqData.mediaContent"
                  style="max-width: 100%; max-height: 300px"
                  controls
                ></video>
              </b-col>
            </b-row>  
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { mapState } from "vuex";
export default {
  name: "Viewfaq",
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
    ComponentHeader,
  },
  data: () => {
    return {};
  },
  // props: {
  //   faqData: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    ...mapState({
      faqData: (state) => state.faq.faqData,
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    downloadFile() {
      window.open(this.faqData.mediaContent);
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
